import type React from 'react';
import type { MouseEventHandler } from 'react';
import styles from 'src/components/PDF/PDFThumbnailStyles';

interface PDFThumbnailProps {
  cardImageSrc: string;
  onClickHandler?: MouseEventHandler<HTMLImageElement>;
}

const PDFThumbnail: React.FC<PDFThumbnailProps> = (props) => {
  const classes = styles();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLImageElement>): void => {
    if ((e.key === 'Enter' || e.key === ' ') && props.onClickHandler) {
      e.preventDefault();
      props.onClickHandler(e as unknown as React.MouseEvent<HTMLImageElement>);
    }
  };

  return (
    <div className={classes.imagesContainer}>
      <img
        onClick={props.onClickHandler}
        onKeyDown={handleKeyDown}
        role={props.onClickHandler ? 'button' : undefined}
        tabIndex={props.onClickHandler ? 0 : undefined}
        className={classes.pdfImages}
        src={props.cardImageSrc}
        alt="PDF document preview"
      />
      <div className={classes.pdfModal}></div>
    </div>
  );
};

export default PDFThumbnail;
